/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import { Model } from '@vuex-orm/core'
import fc        from '@/utils/interface'

export default class ActiveModel extends Model {                 
        
    static api     = fc.biz4;    
    static backend = '*';
    static entity  = '-'; 
        
    store(){
        return window.getApp.$store;
    }
    
    static state(){
        return this.store().state;
    }
    
    static isOnline(){
        //return true;
        return window.navigator.onLine;
    }
    
    static index(params = {}){                        
        return this.allOnline(params);
    }    
    
    static one(params = {}){
        return this.oneOnline(params);   
    }
    
    static create(data, params={}){
        data.flag = 'create';
        return this.createOnline(data, params);                 
    }       
    
    static update(data, params={}){
        data.flag = data.flag == 'create' || data.flag == 'notif-create' ? 'create' : 'update';        
        return this.updateOnline(data, params);                 
    }
    
    /*static delete(data = {}, params={}){        
        return this.deleteOnline(data, params);         
    }*/

    static view(params = {}){
        return this.api.get(this.backend + 'view', params).then(res =>{
            return res.status === 200 ? res.data : this.oneOffline(this.entity, params);
        })
    }
                                           
    static allOnline(params = {}){
        return this.api.get(this.backend + 'index', params).then(res => {
            return res.status === 200 ? res.data : {data:[], pagination:{}};
        });
    }    
    
    static oneOnline(params = {}){
        return this.api.get(this.backend + 'findbyid', params).then(res =>{
            return res.status === 200? res.data : this.oneOffline(this.entity, params);
        })
    }
    
    static createOnline(data, params={}){
        return this.api.post(this.backend + 'create', data, params).then(res => {            
            if(res.status == 0){
                let ID = Math.random().toString(36).substr(2, 9);
                data.id         = ID;
                data.offline_id = ID;
                this.createOrUpdateOfflineTime(this.entity, data);
            } else {
                return res;
            }            
        });
    }
    
    static updateOnline(data, params={}){
        return this.api.put(this.backend + 'update', data, params).then(res => {
            if(res.status == 0){
                this.createOrUpdateOfflineTime(this.entity, data)
            } else {
                return res;
            }
        });        
    }
    
    static deleteOnline(data = {}, params={}){
        return this.api.delete(this.backend + 'delete', data, params);        
    }       

    static allOffline(entity, params = {}){
        let query = window.getApp.$store.getters['entities/'+entity+'/query']();
        for(var key in params){                
            query = query.where(key, params[key]);
        }
        return query.get();        
    }

    static oneOffline(entity, params = {}){
        let exc = ['expand','sortby'];
        let query = window.getApp.$store.getters['entities/'+entity+'/query']();
        for(var key in params){       
            if(!exc.includes(key)){
                query = query.where(key, params[key]);
            }                                             
        }
        return query.first();        
    }

    static createOrUpdateOfflineTime(entity, data){        
        return window.getApp.$store.dispatch('entities/'+entity+'/insertOrUpdate', {data : data}).then(()=>{
            return {status: 200, data : window.getApp.$store.getters['entities/'+entity+'/query']().last()}
        });
    }
    
}